export const formHotkeysMap = {
  submit: 'meta+enter',
};
